import { apiClient } from '@copro/api';
import { useQuery } from '@tanstack/react-query';
import { keys } from './keys';

async function fetchQuoteGroup(groupId: string) {
  const { data, error } = await apiClient
    .from('quote_comparison_groups')
    .select('*')
    .eq('id', groupId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data;
}

export function useGetQuoteGroup(groupId: string | undefined) {
  return useQuery({
    queryKey: keys.group(groupId ?? ''),
    queryFn: () => fetchQuoteGroup(groupId!),
    enabled: !!groupId,
  });
}
